import React, { useMemo } from "react";
import { IconButton, Switch, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import Constants, { Icons } from "utils/Constants";

const ProjectDprKpiData = ({ kpiList, handleEdit, handleDelete, handleStatusToggle }) => {
  const columns = useMemo(
    () => [
      { Header: "No.", accessor: "srNo", width: "5%" },
      { Header: "Name", accessor: "name", width: "40%" },
      { Header: "Sort Order", accessor: "sortOrder", width: "15%" },
      { Header: "Status", accessor: "status", width: "20%" },
      { Header: "Actions", accessor: "actions", width: "20%" },
    ],
    []
  );

  const rows = useMemo(
    () =>
      (kpiList || []).map((kpi, index) => ({
        srNo: index + 1,
        name: kpi.name,
        sortOrder: kpi.sortOrder ?? "-",
        status: (
          <Switch
            color="info"
            checked={kpi.isActive}
            onChange={(event) =>
              handleStatusToggle(kpi[Constants.MONGOOSE_ID], event.target.checked)
            }
          />
        ),
        actions: (
          <MDBox display="flex" alignItems="center">
            <Tooltip title="Edit KPI">
              <IconButton color="info" onClick={() => handleEdit(kpi)} sx={{ mr: 1 }}>
                {Icons.EDIT}
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete KPI">
              <IconButton
                color="info"
                onClick={() => handleDelete("DPR KPI", kpi[Constants.MONGOOSE_ID])}
              >
                {Icons.DELETE}
              </IconButton>
            </Tooltip>
          </MDBox>
        ),
      })),
    [kpiList, handleEdit, handleDelete, handleStatusToggle]
  );

  return { columns, rows };
};

export default ProjectDprKpiData;
